import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';

export const routes = {
  messagingUrlPath: () => '/api/messaging/url',
  messagingGroupsLookupPath: () => '/api/messaging/messagingGroups/lookup',
  reportsAveragePath: (params) => `/api/messagingReports/averages${getQueryParams(params)}`,
  reportsClaimedByUserPath: (params) => `/api/messagingReports/claimedByUser${getQueryParams(params)}`,
  // messaging groups
  messagingGroupsPath: (params) => `/api/MessagingGroups${getQueryParams(params)}`,
  messagingGroupDepartmentsPath: () => '/api/MessagingGroups/Departments',
  messagingGroupsSearchProps: () => '/api/MessagingGroups/SearchProperties',
  messagingGroupPathById: (id) => `/api/MessagingGroups/${id}`,
  restoreMessagingGroupPath: (id) => `/api/MessagingGroups/${id}/restore`,
  auditsMessagingGroupPathById: (id, params) => `/api/MessagingGroups/${id}/Audits${getQueryParams(params)}`,
};

export const getMessagingUrl = () => makeRequest(authFetch.get(routes.messagingUrlPath()));
export const getMessagingUrl2 = () => makeRequest(authFetch.get('/api/Messaging/maintenanceUrl'));

export const getMessagingGroupsLookup = () => makeRequest(authFetch.get(routes.messagingGroupsLookupPath()));
export const getMessagingGroupDepartments = () => makeRequest(authFetch.get(routes.messagingGroupDepartmentsPath()));

export const getMessagingAverageReport = (params) => makeRequest(authFetch.get(routes.reportsAveragePath(params)));

export const getClaimedByUserReport = (params) => makeRequest(authFetch.get(routes.reportsClaimedByUserPath(params)));

// messaging groups
export const getMessagingGroupsSearchProps = () => makeRequest(
  authFetch.get(routes.messagingGroupsSearchProps()),
);

export const getMessagingGroups = (params) => authFetch
  .get(routes.messagingGroupsPath(params))
  .catch((error) => {
    console.error(error);
    throw error;
  });

export const postMessagingGroup = (messagingGroup) => makeRequest(
  authFetch.put(routes.messagingGroupsPath(), messagingGroup),
);

export const deleteMessagingGroup = (id) => makeRequest(
  authFetch.delete(routes.messagingGroupPathById(id)),
);

export const restoreMessagingGroup = (id) => makeRequest(
  authFetch.patch(routes.restoreMessagingGroupPath(id)),
);

export const getMessagingGroupAudits = (id, params) => makeRequest(
  authFetch.get(routes.auditsMessagingGroupPathById(id, params)),
);

/**
 * {
  "content": "string",
  "media": {
    "name": "string",
    "data": "string",
    "url": "string"
  },
  "driverId": 0,
  "groupId": 0
}
 */

export const sendMessageToDriver = ({ messagingUrl, data }) => makeRequest(
  authFetch.patch('api/employees/conversations/initiate', data, { baseUrl: messagingUrl }),
);

export const getDriverMessageGroup = (messagingUrl, driverId) => makeRequest(
  authFetch.get(`api/dispatcher/${driverId}/DriverMessageGroup`, { baseUrl: messagingUrl }),
);

// Messaging V2 (uses its own config)
let configV2 = { withCredentials: false };

export const setMessagingV2Client = (props) => {
  configV2 = { ...configV2, ...props };
};

const authFetchV2 = {
  get: (path) => authFetch.get(path, configV2),
  patch: (path, data) => authFetch.patch(path, data, configV2),
  put: (path, data) => authFetch.put(path, data, configV2),
  post: (path, data) => authFetch.post(path, data, configV2),
  delete: (path) => authFetch.delete(path, configV2),
};

const MESSAGING_GROUPS_PATH = '/api/maintenance/messagingGroups';

// Grid
export const getMessagingV2GroupsSearchProperties = () => makeRequest(authFetchV2.get(`${MESSAGING_GROUPS_PATH}/SearchProperties`));
export const getMessagingV2Groups = (params) => makeRequest(authFetchV2.get(`${MESSAGING_GROUPS_PATH}${getQueryParams(params)}`));

// Details by Id
export const getMessagingV2GroupById = (messagingGroupId) => makeRequest(authFetchV2.get(`${MESSAGING_GROUPS_PATH}/${messagingGroupId}`));
export const saveMessagingV2Group = (data) => makeRequest(authFetchV2.put(MESSAGING_GROUPS_PATH, data));
export const deleteMessagingV2Group = (messagingGroupId) => makeRequest(authFetchV2.delete(`${MESSAGING_GROUPS_PATH}/${messagingGroupId}`));
export const restoreMessagingV2GroupById = (messagingGroupId) => makeRequest(
  authFetchV2.patch(`${MESSAGING_GROUPS_PATH}/${messagingGroupId}/restore`),
);

// Statics
export const getMessagingV2Departments = () => makeRequest(authFetchV2.get(`${MESSAGING_GROUPS_PATH}/Departments`));
export const getMessagingV2Regions = () => makeRequest(authFetchV2.get(`${MESSAGING_GROUPS_PATH}/Regions`));
export const getMessagingV2DriverPreferences = () => makeRequest(authFetchV2.get(`${MESSAGING_GROUPS_PATH}/Preferences`));
export const getMessagingV2UsersLookup = (params) => makeRequest(authFetchV2.get(`${MESSAGING_GROUPS_PATH}/Users${getQueryParams(params)}`));

// Audit
export const getMessagingV2GroupAudits = (id, params) => makeRequest(
  authFetchV2.get(`${MESSAGING_GROUPS_PATH}/${id}/Audits${getQueryParams(params)}`),
);
export const getMessagingV2GroupAuditProperties = (id) => makeRequest(authFetchV2.get(`${MESSAGING_GROUPS_PATH}/${id}/Audits/Properties`));
export const getMessagingV2GroupAuditUsers = (id) => makeRequest(authFetchV2.get(`${MESSAGING_GROUPS_PATH}/${id}/Audits/Users`));
